module.exports = __webpack_public_path__ + "img/shadow_right.70dbd663.png";